module.exports = __webpack_public_path__ + "img/949-2518e6.png";